const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age}  = require("../../Constants");

class Cavalry extends Technology {
    constructor(age, techName, scienceCost, workerCost, multiplier){
        super(
            age,
            Cavalry.GetType(),
            techName,
            scienceCost,
            workerCost,
            {
                playerStateAltering:
                (playerState) => playerState.militaryCalculationDelegate.push({
                    Source: this,
                    Action: () => this.GetWorkerCount() * multiplier,
                })
            }
        )
        // Strength of one unit (e.g. what sacrificing it is worth when colonizing)
        this.multiplier = multiplier;
    }
    static GetType = () => TechnologyTypes.Military.Cavalry;
}

class Knights extends Cavalry {
    constructor(){
        super(Knights.GetAge(), Knights.GetName(), 5, 3, 2)
    }

    static GetInstance = () => new Knights();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Military.Knights;
}

class Cavalrymen extends Cavalry {
    constructor(){
        super(Cavalrymen.GetAge(), Cavalrymen.GetName(), 6, 5, 3)
    }

    static GetInstance = () => new Cavalrymen();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Military.Cavalrymen;
}

class Tanks extends Cavalry {
    constructor(){
        super(Tanks.GetAge(), Tanks.GetName(), 9, 7, 5)
    }

    static GetInstance = () => new Tanks();
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Military.Tanks;
}

module.exports = {
    Knights,
    Cavalrymen,
    Tanks
}